export const BUTTON_COLORS = ['brand', 'white', 'gray', 'destructive'] as const;

export type ButtonColor = (typeof BUTTON_COLORS)[number];
